import { WithCommonProps } from '@types';

export type IAnalyticsRefProps = WithCommonProps<{
  children: React.ReactNode;
  name: string;
}>;

export const AnalyticsRef: React.FC<IAnalyticsRefProps> = ({
  children,
  name,
  ...props
}) => {
  return (
    <div data-tag-ref={name} {...props}>
      {children}
    </div>
  );
};
